import { Link, useLocation } from "react-router-dom";
import {
  CANONICALLS_TRAVERSAL_SPINE,
  resolveCanonicallsTraversalStepWithPhase,
  traversalStepIndex,
  type CanonicallsTraversalId,
} from "../../lib/canonicallsTraversal";
import { CANONICALLS_TRAVERSAL_PHASE_HINT } from "../../lib/canonicallsCopy";
import { ContinuityAnchor } from "./ContinuityAnchor";

function phaseHintForStep(id: CanonicallsTraversalId): string {
  return CANONICALLS_TRAVERSAL_PHASE_HINT[id];
}

export function ContinuityTraversalStrip() {
  const { pathname, search, hash } = useLocation();
  const active = resolveCanonicallsTraversalStepWithPhase(pathname, search, hash);
  const activeIdx = active ? traversalStepIndex(active.id) : -1;
  const activeHint = active ? phaseHintForStep(active.id) : null;

  return (
    <nav className="canonicalls-traversal" aria-label="Continuity traversal">
      <div className="canonicalls-traversal__thread" aria-hidden />
      <ol className="canonicalls-traversal__spine" role="list">
        {CANONICALLS_TRAVERSAL_SPINE.map((step, i) => {
          const isActive = active?.id === step.id;
          const isPast = activeIdx >= 0 && i < activeIdx;
          const isReplay = step.id === "replay";
          return (
            <li
              key={step.id}
              className="canonicalls-traversal__step"
              data-step={step.id}
              data-active={isActive}
              data-past={isPast}
              data-climax={isReplay ? "true" : undefined}
              data-handoff={step.id === "verification" && isPast && active?.id === "replay" ? "to-replay" : undefined}
              aria-current={isActive ? "step" : undefined}
            >
              <Link to={step.to} className="canonicalls-traversal__link" title={step.description}>
                {step.shortLabel}
              </Link>
            </li>
          );
        })}
      </ol>
      {activeHint ? (
        <p className="canonicalls-phase-hint canonicalls-phase-hint--rail" aria-live="polite">
          {activeHint}
        </p>
      ) : null}
      <ContinuityAnchor subtle />
    </nav>
  );
}
